import { EXPORT_IS_DEV } from '../../core/config';
import GA from './base';
import Memory from './memory';

export default EXPORT_IS_DEV(Memory, GA);
